/**
 * Wire types. Everything the API sends or accepts is generated from the
 * server's Rust contract into `./generated/procedures.ts`; this module
 * re-exports it and adds a few vocabulary aliases and type guards.
 */
import type {
  AdminAuthAccount,
  AuthSuccess,
  ConsentChallenge,
  ProjectTenancyMode,
  SignInResult,
  TenantInvitation,
  TenantMember,
  TenantRoleRow,
  TwoFactorChallenge,
} from "./generated/procedures.js";

export type * from "./generated/procedures.js";

// Open string vocabularies: the server accepts and returns plain
// strings, these name the well-known values.
export type UserRole = "superadmin" | "useradmin" | "user" | (string & {});
export type TenantRole = "owner" | "admin" | "member" | (string & {});
export type UserStatus = "active" | "inactive" | "pending" | (string & {});
export type NotificationSurface = "signup" | "login" | "app" | "any";
export type AdminUsersSortBy = "name" | "email" | "createdAt";

// Short names for frequently used generated types.
export type Member = TenantMember;
export type Invitation = TenantInvitation;
export type RoleRow = TenantRoleRow;
export type AuthAccount = AdminAuthAccount;
export type TenancyMode = ProjectTenancyMode;

/** What a passkey sign-in (or a 2FA verify) resolves to. */
export type PasskeySignInResult = AuthSuccess | ConsentChallenge;

export const isTwoFactorChallenge = (
  r: SignInResult
): r is TwoFactorChallenge => "twoFactorRequired" in r && r.twoFactorRequired === true;

export const isConsentChallenge = (
  r: SignInResult | PasskeySignInResult
): r is ConsentChallenge => "consentRequired" in r && r.consentRequired === true;
